import type { ClientEvent } from "@trendator/shared";
import { api } from "./api";

/**
 * События мини-аппа: копим и шлём пачкой раз в 5 секунд и при сворачивании.
 * Только экраны и клики — без текстов промптов и фото. Ошибки отправки молча глотаем.
 */
type Props = Record<string, string | number | boolean | null>;

let queue: { name: ClientEvent; props: Props }[] = [];
let ready = false;
let timer: ReturnType<typeof setTimeout> | null = null;

function schedule() {
  if (timer || !ready || queue.length === 0) return;
  timer = setTimeout(() => {
    timer = null;
    void flush();
  }, 5000);
}

export async function flush(): Promise<void> {
  if (!ready || queue.length === 0) return;
  const batch = queue.slice(0, 20);
  queue = queue.slice(20);
  try {
    await api.events(batch);
  } catch {
    /* аналитика не должна мешать */
  }
  schedule();
}

export function track(name: ClientEvent, props: Props = {}): void {
  queue.push({ name, props });
  if (queue.length > 100) queue = queue.slice(-100);
  if (queue.length >= 20) void flush();
  else schedule();
}

/** После входа (юзер есть на сервере) — начинаем отправлять. */
export function startTracking(): void {
  if (ready) return;
  ready = true;
  if (typeof document !== "undefined") {
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") void flush();
    });
  }
  schedule();
}

/** Для тестов. */
export function resetTracking(): void {
  queue = [];
  ready = false;
  if (timer) clearTimeout(timer);
  timer = null;
}
